module.exports = __webpack_public_path__ + "images/taieri.b2f818bcf7a11ef12d1fc21d4f6c1f41.svg";